import styled from 'styled-components';
import { Breadcrumb as BreadCr } from 'antd';

import { theme, hideOverflowText } from '../../styles';


export const Breadcrumb = styled(BreadCr)`
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;

  > span {
    color: ${theme.colors.secondaryDark};

    a {
      color: ${theme.colors.secondaryDark};

      &:hover {
        color: ${theme.colors.tangerine};
      }
    }

    .ant-breadcrumb-separator {
      margin: 10px;
      color: ${theme.colors.secondaryDark};
    }
    
    :last-child {
      font-size: 15px;
      font-weight: 500;
      color: ${theme.colors.mainDark};
      ${hideOverflowText};
    }
    
    :nth-last-child(2) {
      .ant-breadcrumb-separator {
        font-size: 15px;
        font-weight: 500;
        color: ${theme.colors.mainDark};
      }
    }
  }
`;





// WEBPACK FOOTER //
// ./src/components/ui-helpers/breadcrumb.js